import { render, staticRenderFns } from "./MixerUploads.vue?vue&type=template&id=55ff24bd&lang=pug&"
import script from "./MixerUploads.vue?vue&type=script&lang=js&"
export * from "./MixerUploads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports